<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <!-- <app-header [cartCount]="cartCount"></app-header> -->

  <!-- Page Content -->
  <section class="max-w-5xl mx-auto px-4 py-10">
    <div class="bg-white rounded-2xl shadow-sm p-6 md:p-10">

      <h1 class="text-2xl md:text-3xl font-semibold text-gray-800 mb-6">
        Privacy Policy
      </h1>

      <p class="text-sm text-gray-600 mb-8 leading-relaxed">
        At <span class="font-medium text-gray-800">capitalfood.in</span>, we respect your privacy
        and are committed to protecting the personal information you share with us.
        This Privacy Policy explains how we collect, use, store, and safeguard your
        information when you access or use our website.
      </p>

      <div class="space-y-8 text-sm text-gray-700 leading-relaxed">

        <!-- 1 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">1. Information We Collect</h2>
          <p>When you visit or use capitalfood.in, we may collect the following information:</p>

          <div class="mt-2 space-y-2">
            <p class="font-medium text-gray-700">a) Personal Information</p>
            <ul class="list-disc pl-5 space-y-1">
              <li>Name</li>
              <li>Contact details (phone number, email address)</li>
              <li>Delivery-related information (only when applicable)</li>
            </ul>

            <p class="font-medium text-gray-700 mt-2">b) Non-Personal Information</p>
            <ul class="list-disc pl-5 space-y-1">
              <li>Browser type</li>
              <li>Device information</li>
              <li>IP address</li>
              <li>Website usage data</li>
            </ul>
          </div>
        </div>

        <!-- 2 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">2. Use of Cookies</h2>
          <p>capitalfood.in uses cookies to:</p>
          <ul class="list-disc pl-5 space-y-1 mt-1">
            <li>Improve website performance and user experience</li>
            <li>Remember user preferences</li>
            <li>Enable smooth navigation and faster access</li>
            <li>Analyze website traffic and behavior</li>
          </ul>
          <p class="mt-2">
            By using our website, you consent to the use of cookies. You may manage
            or disable cookies through your browser settings; however, some features
            may not function properly if cookies are disabled.
          </p>
        </div>

        <!-- 3 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">3. How We Use Your Information</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Operate and manage our website</li>
            <li>Process food orders, including bulk and large-quantity orders</li>
            <li>Improve our services and offerings</li>
            <li>Communicate order-related updates</li>
            <li>Ensure security and prevent fraudulent activity</li>
          </ul>
        </div>

        <!-- 4 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">4. Food Delivery Partners</h2>
          <p>
            capitalFood.in is a direct partner with Swiggy and Zomato.
            Delivery-related services, including order fulfillment and tracking,
            are handled by these third-party platforms.
          </p>
          <p class="mt-1">
            Their respective privacy policies govern how they collect and process
            user data. capitalfood.in does not control or take responsibility for
            the data practices of third-party delivery partners.
          </p>
        </div>

        <!-- 5 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">5. Data Storage & Security</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>All user-related data is stored securely using cookies and standard security measures</li>
            <li>Reasonable safeguards are implemented to protect data</li>
            <li>No method of online transmission is completely secure</li>
          </ul>
        </div>

        <!-- 6 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">6. Bulk Orders & Business Customers</h2>
          <p>
            For bulk, corporate, or large-quantity orders, additional details may be
            collected solely for order processing, coordination, and delivery purposes.
            Such information is used strictly for service fulfillment.
          </p>
        </div>

        <!-- 7 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">7. Service Availability</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Website services are available Monday to Saturday</li>
            <li>Operating Hours: 11:00 AM to 06:00 PM</li>
            <li>Data collected outside operational hours is handled in accordance with this policy</li>
          </ul>
        </div>

        <!-- 8 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">8. Sharing of Information</h2>
          <p>capitalfood.in does not sell, trade, or rent personal information.</p>
          <ul class="list-disc pl-5 space-y-1 mt-1">
            <li>Required to fulfill an order</li>
            <li>Necessary for legal or regulatory compliance</li>
            <li>Shared with trusted partners strictly for service delivery</li>
          </ul>
        </div>

        <!-- 9 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">9. User Rights</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Request access to personal information</li>
            <li>Request correction or deletion of data</li>
            <li>Withdraw consent for cookie usage (subject to technical limitations)</li>
          </ul>
        </div>

        <!-- 10 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">10. Children’s Privacy</h2>
          <p>
            capitalfood.in does not knowingly collect personal information from
            individuals under the age of 18. If such data is identified, it will
            be removed promptly
          </p>
        </div>

        <!-- 11 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">11. Changes to This Privacy Policy</h2>
          <p>
            capitalfood.in reserves the right to update or modify this Privacy Policy
            at any time. Updates will be effective immediately upon posting.
          </p>
        </div>

        <!-- 12 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">12. Governing Law</h2>
          <p>
            This Privacy Policy shall be governed and interpreted in accordance
            with the laws of India.
          </p>
        </div>

        <!-- 13 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">13. Contact Us</h2>
          <p>
            If you have any questions or concerns regarding this Privacy Policy,
            please contact us using the details provided on capitalfood.in.
          </p>
        </div>

      </div>
    </div>
  </section>

  <!-- Footer -->
  <!-- <app-footer></app-footer> -->
</div>
